import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { WARRANTY_TYPES } from "models";
import "modules/DealerOverviewDashboard/components/DmsSystem/components/SnoozeAndWarranty/SnoozeAndWarranty.scss";
import { enumToDropdownOptions } from "utils/common";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const SnoozeAndWarranty = () => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const [snoozeNextVisit, snoozeRemind, snoozeMakeNew, snoozeMakeOffer, enabledWarrantyTypes] = watch([
    "is_snooze_type_next_visit_customer_enabled",
    "is_snooze_type_remind_customer_enabled",
    "is_snooze_type_make_new_appointment_enabled",
    "is_snooze_type_make_offer_enabled",
    "enabled_warranty_types"
  ]);

  const snoozeTypeError = formState.isSubmitted && !(snoozeNextVisit || snoozeRemind || snoozeMakeNew || snoozeMakeOffer);
  const warrantyError = formState.isSubmitted && !enabledWarrantyTypes?.length;
  const warrantyOptions = enumToDropdownOptions({ enumObj: WARRANTY_TYPES, t, keysToExclude: ["FirstFromNotSet", "NotSet"] });

  return (
    <Form.Group className="SnoozeAndWarranty">
      <Form.Field width={3} required error={snoozeTypeError}>
        <div className="dealer-overview-subheading">{t("v8_snooze_type", "Snooze type")}</div>
        <FormHelper.Field.Checkbox name="is_snooze_type_next_visit_customer_enabled" label={t("v8_next_visit_customer", "Next visit customer")} />
        <FormHelper.Field.Checkbox name="is_snooze_type_remind_customer_enabled" label={t("v8_remind_customer", "Remind customer")} />
        <FormHelper.Field.Checkbox name="is_snooze_type_make_new_appointment_enabled" label={t("v8_make_new_appointment", "Make new appointment")} />
        <FormHelper.Field.Checkbox name="is_snooze_type_make_offer_enabled" label={t("v8_make_an_offer", "Make an offer")} />
      </Form.Field>
      <Form.Field width={7}>
        <div className="dealer-overview-subheading">{t("v8_snooze_settings", "Snooze settings")}</div>
        <FormHelper.Field.Checkbox name="is_snooze_status_enabled" label={t("v8_snooze_status", "Snooze Status")} />
        <FormHelper.Field.Checkbox name="is_snooze_department_enabled" label={t("v8_department", "Department")} />
        <FormHelper.Field.Checkbox name="is_snooze_attachment_enabled" label={t("v8_attachments", "Attachments")} />
      </Form.Field>
      <Form.Field width={6} required error={warrantyError}>
        <div className="dealer-overview-subheading">{t("v8_warranty_type_settings", "Warranty type settings")}</div>
        <label>{t("v8_warranty_types", "Warranty types")}</label>
        <FormHelper.Field.Dropdown
          name="enabled_warranty_types"
          options={warrantyOptions}
          dropdownProps={{ multiple: true, selection: true, placeholder: t("v8_warranty_types", "Warranty types") }}
        />
      </Form.Field>
    </Form.Group>
  );
};
